module.exports = __webpack_public_path__ + "static/img/cutemobi18-logo.57ae9eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cutemobi/imgs/cutemobi18-logo.png
// module id = 2249
// module chunks = 0